import React, { useEffect, useState } from 'react';
import { collection, query, orderBy, limit, onSnapshot, DocumentData } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';
import { getFunctions, httpsCallable } from 'firebase/functions';

const NotificationsBell: React.FC = () => {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState<DocumentData[]>([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    const q = query(collection(db, 'app_notifications'), orderBy('sentAt', 'desc'), limit(20));
    const unsub = onSnapshot(q, snap => {
      setNotifications(snap.docs.map(d => ({ id: d.id, ...(d.data() as any) })));
      setLoading(false);
    }, err => { console.error('Erro ao escutar notificações:', err); setLoading(false); });

    return () => unsub();
  }, [user]);

  const unreadCount = notifications.filter(n => !(n.readBy && Array.isArray(n.readBy) && n.readBy.includes(user?.uid))).length;

  const markRead = async (id: string) => {
    try {
      const fns = getFunctions();
      const markFn = httpsCallable(fns, 'markNotificationRead');
      await markFn({ id });
    } catch (err) {
      console.error('Erro ao marcar notificação como lida', err);
      alert('Erro ao marcar como lida. Tente novamente.');
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <button aria-label="Notificações" onClick={() => setOpen(v => !v)} className="notification-bell">
        <span style={{display:'inline-flex',alignItems:'center',gap:8}}><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 22a2 2 0 0 0 2-2H10a2 2 0 0 0 2 2zm6-6V10c0-3.07-1.64-5.64-4.5-6.32V3a1.5 1.5 0 0 0-3 0v.68C7.64 4.36 6 6.92 6 10v6l-2 2v1h16v-1l-2-2z"/></svg>{unreadCount > 0 && <span className="badge">{unreadCount}</span>}</span>
      </button>
      {open && (
        <div className="notifications-dropdown">
          <div style={{ padding: 8, borderBottom: '1px solid #eee' }}><strong>Notificações</strong></div>
          {loading ? <div style={{ padding: 12 }}>Carregando...</div> : (
            notifications.length === 0 ? <div style={{ padding: 12 }}>Nenhuma notificação</div> : (
              <ul style={{ listStyle: 'none', margin: 0, padding: 8 }}>
                {notifications.map(n => (
                  <li key={n.id} style={{ padding: 8, borderBottom: '1px solid #f1f1f1' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                      <div>
                        <div style={{ fontWeight: 600 }}>{n.title}</div>
                        <div style={{ fontSize: 13 }}>{n.body}</div>
                        <div style={{ fontSize: 11, color: '#666', marginTop: 6 }}>{(n.sentAt && (n.sentAt.toDate ? n.sentAt.toDate().toLocaleString('pt-BR') : (typeof n.sentAt === 'string' ? new Date(n.sentAt).toLocaleString('pt-BR') : String(n.sentAt)))) || ''}</div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        {!(n.readBy && Array.isArray(n.readBy) && n.readBy.includes(user?.uid)) && (
                          <button onClick={() => markRead(n.id)} className="primary">Marcar como lida</button>
                        )}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationsBell;
